<p style="text-align: center; margin: auto;">Stripe payment processing...</p>
<p id="message"></p>
